import {
	IChatMessage,
	IFormConfig,
	IMessageCommandMeta,
	MinMaxSource,
	IMessageCommandFormExtraParameters,
} from '@enuan/chat__utils';
import { createContext } from 'react';

export type IFrameState = {
	isOpen: { isOpen: boolean; payload?: any; source?: MinMaxSource };
	page: 'messages' | 'survey' | 'form' | 'closed' | undefined;
	isStandalone: boolean;
	hidePopup: boolean;
	isFullscreen: boolean;
	isDetached: boolean;
	formData?: {
		config: Partial<IFormConfig<IMessageCommandFormExtraParameters>>;
		message?: {
			command_id: IMessageCommandMeta['id'];
			client_id: IChatMessage['client_id'];
		};
	};
};
export type IFrameStateCallback = {
	toggleChat: (
		isOpen?: IFrameState['isOpen']['isOpen'],
		source?: IFrameState['isOpen']['source'],
		payload?: IFrameState['isOpen']['payload'],
	) => void;
	togglePage: <P extends IFrameState['page']>(
		page: P,
		payload?: P extends 'form' ? IFrameState['formData'] : any,
	) => void;
	setPage: (page: IFrameState['page']) => void;
};
export const frameStateContext = createContext<
	IFrameState & IFrameStateCallback
>({
	isOpen: { isOpen: false },
	toggleChat: () => {},
	page: 'messages',
	togglePage: () => {},
	setPage: () => {},
	isStandalone: false,
	hidePopup: false,
	isFullscreen: false,
	isDetached: false,
});
